module.exports = __webpack_public_path__ + "static/media/15.102.c3d6eb70.jpg";